import {Component, OnInit} from '@angular/core';
import {Output, EventEmitter} from '@angular/core';
import {faFacebook, faInstagram, faTwitter, faYoutube, faWhatsappSquare, faTiktok, faLinkedin} from '@fortawesome/free-brands-svg-icons';
import { faPhoneSquare, faFax, faDeaf, faMicrophoneAlt } from '@fortawesome/free-solid-svg-icons';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import {Path} from '../../util/path';
@Component({
    selector: 'app-rodape',
    templateUrl: './rodape.component.html',
    styleUrls: ['./rodape.component.scss'],
    standalone: false
})

export class RodapeComponent implements OnInit {

    @Output() isVisibleEvent = new EventEmitter<boolean>();
    @Output() mapaEvent = new EventEmitter<boolean>();
    pathFormularioSIC = Path.SIC_OUVIDORIA_FORMULARIO;

    constructor() {
    }

    onIntersection({visible}: { visible: boolean }): void {
        this.isVisibleEvent.emit(visible);
    }

    mostrarMapa(): void {
        this.mapaEvent.emit(true);
    }

    ngOnInit(): void {
    }

    faFacebook = faFacebook;
    faMicrophoneAlt = faMicrophoneAlt;
    faInstagram = faInstagram;
    faTwitter = faTwitter;
    faYoutube = faYoutube;
    faTiktok = faTiktok;
    faLinkedin = faLinkedin;
    faWhatsappSquare = faWhatsappSquare;
    faPhoneSquare = faPhoneSquare;
    faFax = faFax;
    faDeaf = faDeaf;
    faEyeSlash = faEyeSlash;
}
